import styled, { keyframes } from 'styled-components'
import * as Defines from '../../utils/defines/defines'

/**
 * Por padrão o botão usa o estilo "Glass Elevated" (translúcido, igual aos
 * cards). Passe `$gradient` para o estilo Neumórfico/gradiente — reservado
 * para Login, "Ir para Dashboard" e "Sair".
 */
export const Button = styled.button<{ $gradient?: boolean }>`
    height: 40px; 
    border: none;
    transition: .2s;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    font-family: "Nunito";

    cursor: pointer;
    position: relative;
    display: flex;
    grid-gap: 0px 10px;
    white-space: nowrap;

    ${props => props.$gradient ? `
        background: linear-gradient(90deg, #92B258, #5292D1);
        color: #FFF;
        box-shadow: 0 6px 16px rgba(0,0,0,0.45);
        border-radius: 999px;
    ` : `
        background: ${Defines.GlassCardBg};
        border: ${Defines.GlassCardBorder};
        backdrop-filter: ${Defines.GlassCardBlur};
        color: rgba(255,255,255,0.85);
        box-shadow: ${Defines.GlassCardShadow};
    `}

    :hover{
        filter: brightness(1.08);
        transform: translateY(-1px);
    }

    :disabled{
        cursor: default;
        opacity: 0.5;
        filter: none;
        transform: none;
    }
`

export const SecondaryButton = styled(Button)`
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.14);
    color: rgba(255,255,255,0.75);
    box-shadow: none;

    :hover{
        background: rgba(255,255,255,0.09);
        filter: none;
        transform: none;
    }
`

const pulse = keyframes`
    0%, 100% { opacity: 0.3; transform: scale(0.85); }
    50% { opacity: 1; transform: scale(1); }
`

export const LoadingDots = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;

    span {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #fff;
        opacity: 0.4;
        display: block;
        animation: ${pulse} 1s ease-in-out infinite;
    }
    span:nth-child(2) { animation-delay: 0.15s; }
    span:nth-child(3) { animation-delay: 0.3s; }
`
